export default {
  muiProKey: process.env.REACT_APP_MUI_PRO_KEY || '',
};
